export const PAYMENT_CONFIRMATION_ROUTE = 'payment';
export const PAYMENT_CONFIRMATION_BILL_ID_PARAMETRIZED_ROUTE = 'payment/:billid';
